
/**
 * Custom component for Romanza dessert items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.0
 * @copyright  Copyright (C) 2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2025-03-31 (1.0.0) (jhoward)
 *      - <romanza-default-item> copied to <romanza-dessert-item>.
 */

import {defineComponent, PropType} from "vue";
import {MENU_ITEM_LAYOUT, MenuItem} from "../defs";
import RomanzaDefaultItem from "./Romanza_defaultItem.vue";

export default defineComponent({
  name: 'romanza-dessert-item',
  components: {
    RomanzaDefaultItem,
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    priceLayout: {
      type: String as PropType<MENU_ITEM_LAYOUT>,
      default: 'price-inline'
    }
  },
})
